import { createFileRoute } from "@tanstack/react-router";

import { coachContentHubQueryOptions } from "src/components/contentHubQueries";
import { ContentHubAssignedAthletesPage } from "src/pages/ContentHubAssignedAthletesPage";

export const Route = createFileRoute(
  "/_auth/_coach/content-hub/$contentHubId/assigned-athletes",
)({
  component: RouteComponent,
  ssr: true,
  async loader(props) {
    const contentHub = await props.context.queryClient.query({
      ...coachContentHubQueryOptions(props.params.contentHubId),
      staleTime: "static",
    });

    return {
      breadcrumb: {
        id: contentHub.id,
        label: contentHub.title,
        href: `/content-hub/${contentHub.id}`,
      },
    };
  },
});

function RouteComponent() {
  const params = Route.useParams();

  return <ContentHubAssignedAthletesPage contentHubId={params.contentHubId} />;
}
